angular.module('NiacsProjectApp.services-general',[
])
.factory('CourseOfferingService',['$q','CourseOffering',function($q,CourseOffering){
  var offerings = {},
      fetching = false,
      service = {
        getForProject: function(p) {
          if(!offerings[p.id]) {
            offerings[p.id] = {
              def: $q.defer(),
              o: undefined,
            };
            if(p.training && p.training.course && p.training.course_offering) {
              if(!fetching) {
                fetching = true;
                CourseOffering.get({id:p.training.course,offering: p.training.course_offering},function(course){
                  offerings[p.id].def.resolve(offerings[p.id].o = course);
                  fetching = false;
                });
              }
            } else {
              offerings[p.id].def.resolve(); // none
            }
          }
          return offerings[p.id].def.promise;
        }
      };
  return service;
}])
.factory('MenuService',['$q','ProjectService','CourseOfferingService',function($q,ProjectService,CourseOfferingService){
  function MenuPath($location) {
    var stringVal = typeof($location) === 'string' ? $location : $location.path(),
        parts = stringVal.split('/'),
        step = parts[1],
        projectId = parts[2],
        params = parts.length === 4 ? parts[3] : undefined;
    return {
      getStep: function() { return step; },
      getProjectId: function() { return projectId; },
      getParams: function() { return params; },
      toString: function() { return stringVal; },
      compareToMenuItem: function (item) {
        return stringVal == item.toString();
      }
    };
  }
  function MenuItem(item,pid) {
    var projectId = pid,
        self = {
      toString: function() {
        return '/'+self.item+'/'+projectId+(self.params?self.params:'');
      }
    };
    return angular.extend(self,item);
  }
  var flatMenu,
      service = {
        getStepInfo: function($location) {
          var def = $q.defer();
          service.getFlatMenu().then(function(flat){
            var current = new MenuPath($location),active,i;
            for(i = 0; i < flat.length; i++) {
              if(current.compareToMenuItem(flat[i])) {
                active = flat[i];
                break;
              }
            }
            // now move backward until we find one without an item (the parent step)
            while(i >= 0) {
              if(!flat[i].item) {
                def.resolve({
                  stepName: flat[i].label,
                  active: active,
                  parent: flat[i]
                });
                break;
              }
              i--;
            }
          });
          return def.promise;
        },
        getMenuPath: function($location) {
          return new MenuPath($location);
        },
        isMenuItemActive: function(item,$location) {
          return (new MenuPath($location)).compareToMenuItem(item);
        },
        getFlatMenu: function($routeParams,uniqueId) {
          var def = $q.defer();
          if(flatMenu) {
            def.resolve(flatMenu);
          } else {
            ProjectService.get($routeParams,uniqueId,function(project){
              CourseOfferingService.getForProject(project).then(function(course){
                  if(course && course.homework) {
                      // stitch the homework into the menu structure
                      Object.keys(course.homework).forEach(function(key){
                          if(niacs.menu[key]) {
                              course.homework[key].forEach(function(hwItem) {
                                  niacs.menu[key][hwItem.title] = {template:'homework',params:'/'+hwItem.id};
                              });
                          }
                      });
                  }
                  def.resolve(flatMenu = niacs.flattenMenu().map(function(item) { return new MenuItem(item,project.id); }));
              });
            });
          }
          return def.promise;
        }
      };
  return service;
}])
.factory('RedirectionService',['ProjectService','ShowHideService','PaneStateService','$location','$rootScope','$timeout',function(ProjectService,ShowHideService,PaneStateService,$location,$rootScope,$timeout){
  var focusPanelsOnChange = null;
  function locationChange(event) {
    if(focusPanelsOnChange) {
        niacs.debug('focusPanelsOnChange',focusPanelsOnChange);
        $timeout(function(){
            angular.forEach(focusPanelsOnChange,function(uniqueId) {
                PaneStateService.activate(uniqueId);
                ShowHideService.open(uniqueId);
            });
            focusPanelsOnChange = null;
        },1000);
    }
  }
  $rootScope.$on('$locationChangeSuccess',locationChange);
  var service = {
    visit : function(view,uniqueId) {
        niacs.debug('visit',view,uniqueId);
        var panelIds = [uniqueId],i;
        for(i = 2;  i < arguments.length; i++) {
            if(arguments[i]) { panelIds.push(arguments[i]); }
        }
        ProjectService.get(null,null,function(project){
            if(project) {
                focusPanelsOnChange = panelIds;
                var newPath = '/'+view+'/'+project.id;
                if(newPath === $location.path()) {
                  locationChange(null);
                } else {
                  $location.path('/'+view+'/'+project.id);
                }
            }
        });
    }
  };
  return service;
}])
.factory('UserProfileService',['$http',function($http) {
  var profile = null;
  var activeRequest = false;
  var callbacks = [];
  var service = {
    get: function(callback) {
      if(profile) {
        callback(profile);
      } else {
        callbacks.push(callback);
        if(!activeRequest) {
          // this never goes back to false, should only need to load the
          // profile one time, should instead just use Promises...
          activeRequest = true;
          $http.get('/jsonapi').success(function(data) {
            $http.get(data.meta.links.me.href,{
              params: {
                include: 'roles'
              }
            }).success(function(me) {
              var atts = me.data.attributes;
              var roles = (me.included||[]).filter(function(inc) {
                return inc.type === 'user_role--user_role';
              }).map(function(role) {
                return role.attributes.label;
              });
              profile = {
                id: me.data.id,
                changed: (new Date(atts.changed)).getTime(),
                contact: atts.field_user_contact,
                created: (new Date(atts.created)).getTime(),
                email: atts.mail,
                full_name: atts.field_user_fullname,
                //id: atts.drupal_internal__uid, was profile id
                isAdmin: roles.indexOf('administrator') !== -1,
                org: atts.field_user_organization,
                uid: atts.drupal_internal__uid
              };
              angular.forEach(callbacks,function(cb) {
                cb(profile);
              });
              callbacks = [];
            });
          });
        }
      }
    }
  };
  return service;
}])
.factory('TaxonomyService',['$http',
  function($http){
    var taxonomies = [];
    var callbacks = {};
    var service = {
      get: function(vocabulary,callback) {
        if(taxonomies[vocabulary]) {
          callback(taxonomies[vocabulary]);
        } else if (callbacks[vocabulary]) {
          callbacks[vocabulary].push(callback);
        } else {
          callbacks[vocabulary] = [];
          callbacks[vocabulary].push(callback);
          var params = {
            "page[limit]": "999",
            sort: "weight"
          };
          params['fields[taxonomy_term--'+vocabulary+"]"] = "name,drupal_internal__tid";
          $http.get('/jsonapi/taxonomy_term/'+vocabulary,{
            params: params
          }).success(function(data) {
            taxonomies[vocabulary] = data.data.map(function(d) {
                return {
                  uuid: d.id,
                  id: d.attributes.drupal_internal__tid,
                  label: d.attributes.name
                };
              });
            angular.forEach(callbacks[vocabulary],function(cb){
              cb(taxonomies[vocabulary]);
            });
            callbacks[vocabulary] = null;
          });
        }
      }
    };
    return service;
}])
.factory('NotificationService',['$timeout','$sce','AutoSaveService',function($timeout,$sce,AutoSaveService){
    var alerts = [];
    var closeAlert = function(index){
        alerts.splice(index,1);
    };
    var service = {
        closeAlert: closeAlert,
        getAlerts: function() {
            return alerts;
        },
        addError: function(message) {
            message = $sce.trustAsHtml(message);
            alerts.push ({type:'danger',msg:message});
            // in case the error was during an update
            AutoSaveService.saveComplete();
        },
        addInfo: function (message) {
            message = $sce.trustAsHtml(message);
            var ttl = 5000;
            if ( arguments.length > 1 ) { ttl = arguments[1]; }
            var index = (alerts.push({type:'success',msg:message})-1);
            if ( ttl > 0 ) {
              $timeout(function(){closeAlert(index);},ttl);
            }
        },
        clear: function() {
          alerts.length = 0;
        }
    };
    return service;
}])
.factory('CustomTextService',['$q','$sce','NiacsCustomizableText','ProjectService','NiacsStrategyService',
  function($q,$sce,NiacsCustomizableText,ProjectService,NiacsStrategyService){
      var textsDef = $q.defer(),
          service,
          keys,
          replacements = {};
      (function() {
        var limit = 50; // max allowed by JSON API
        var offset = 0;
        var allTexts = [];
        function next() {
          NiacsCustomizableText.query(
            {
              'page[limit]': limit,
              'page[offset]': offset
            },function(results){
            results.list.forEach(function(text){
                text.text = niacs.htmlToText(text.description);
                text.html = $sce.trustAsHtml(text.description);
            });
            allTexts = allTexts.concat(results.list);
            if(results.list.length < limit) {
              keys = allTexts.map(function(ct){ return ct.label; });
              textsDef.resolve(allTexts);
            } else {
              offset += limit;
              next();
            }
          });
        }
        next();
      })();
      
    service = {
        // this is unfortunate that this cannot be deferred but the nag screens
        // require synchronous functionality (this was already kind of an issue).
        exists: function(key) {
            return keys && keys.indexOf(key) !== -1;
        },
        // and another unfortunate mechanism for the LMS...
        replace: function(key,obj) {
            replacements[key] = obj;
        },
        objects: function(key) {
            var def = $q.defer();
            textsDef.promise.then(function(texts) {
                var list = texts.filter(function(t) {
                    return t.label === key;
                });
                if(!list.length) {
                    def.resolve(undefined);
                } else {
                    def.resolve(list);
                }
            });
            return def.promise;
        },
        object: function(key) {
            var def = $q.defer();
            if(replacements[key]) {
                def.resolve(replacements[key]);
                return def.promise;
            }
            ProjectService.load().then(function(p) {
                service.objects(key).then(function(list){
                    if(!list){
                        def.resolve(undefined);
                    } else if (list.length === 1) {
                        def.resolve(list[0]);
                    } else {
                        NiacsStrategyService.getSources().then(function(sources) {
                            var precedence = sources.map(function(s) { return s.getSource(); }),
                                dflt = list.reduce(function(found,text){
                                    return found||(!text.sector ? text : undefined); // the original with no sector set
                                },undefined),
                                map = list.reduce(function(map,text){
                                    if(text.sector) {
                                        map[text.sector] = text;
                                    }
                                    return map;
                                },{}),i;
                            // select the most appropriate if there is one
                            for(i = 0; i < precedence.length; i++) {
                                // project creation currently only supports selecting a single type so this
                                // precedence code, if/when matches should result in an index of 0 always
                                // i.e. is more complicated than necessary but should be fine.  Leaving in place
                                // since aside from project creation leaving all multi-sector code in place.
                                if(p.strategy_sources.indexOf(precedence[i]) !== -1 && map[precedence[i]]) {
                                    //console.log('found a customizable text for '+precedence[i],map[precedence[i]]);
                                    return def.resolve(map[precedence[i]]);
                                }
                            }
                            // go with the default
                            def.resolve(list.reduce(function(found,text){
                                return found||(!text.sector ? text : undefined); // the original with no sector set
                            },undefined));
                        });
                    }
                });
            });
            return def.promise;
        },
        html: function(key) {
            var def = $q.defer();
            service.object(key).then(function(o) {
                def.resolve(o ? o.html : undefined);
            });
            return def.promise;
        },
        text: function(key) {
            var def = $q.defer();
            service.object(key).then(function(o) {
                def.resolve(o ? o.text : undefined);
            });
            return def.promise;
        }
    };
    return service;
}])
.directive('customPlaceholder',['$compile','CustomTextService',function($compile,CustomTextService){
    return {
        restrict: 'A',
        scope: {
        },
        link: function($scope,$elm,$attrs) {
            $attrs.$observe('customPlaceholder',function(key) {
                if(key) {
                    $elm.parent().prepend($compile('<edit-cust-text add-classes="ta" key="'+key+'"></edit-cust-text>')($scope));
                    CustomTextService.text(key).then(function(result) {
                        $elm.attr('placeholder',result);
                    });
                }
            });
        }
    };
}])
.directive('customText',['CustomTextService',function(CustomTextService){
    return {
        restrict: 'E',
        template: '<edit-cust-text key="{{key}}"></edit-cust-text>{{text}}',
        scope: {
            key: '@'
        },
        link: function($scope) {
            $scope.$watch('key',function(key) {
                delete $scope.text;
                if(key) {
                    CustomTextService.text(key).then(function(text) {
                        $scope.text = text;
                    });
                }
            });
        }
    };
}])
.directive('customHtml',['CustomTextService',function(CustomTextService){
    return {
        restrict: 'E',
        template: '<edit-cust-text key="{{key}}"></edit-cust-text><span ng-bind-html="html"></span>',
        scope: {
            key: '@'
        },
        link: function($scope,$elm,$attrs) {
            $scope.$watch('key',function(key){
                if(key) {
                    if(typeof($attrs.noProject) !== 'undefined') {
                        // working outside of the context of a project
                        CustomTextService.objects(key).then(function(list) {
                            if(list && list.length) {
                                $scope.html = list[0].html;
                            }
                        });
                    } else {
                        CustomTextService.html(key).then(function(result) {
                            $scope.html = result;
                        });
                    }
                } else {
                    delete $scope.html;
                }
            });

        }
    };
}])
/**
 * CacheService
 * Supports a generic place where code can put data that shouldn't be fetched from the
 * server repeatedly, default time to live on data is 5 minutes.
 **/
.factory('CacheService',function(){
    var cache = [];
    var service = {
      dump : function() {
        niacs.info("cache",cache);
      },
      put : function(key,obj) {
        if ( key == null ) {
          return;
        }
        if ( obj == null ) {
          niacs.info ( "removing cached object '"+key+"'", cache[key] );
          // probably should slice to shrink cache array but...
          cache[key] = null;
          return;
        }
        var ttl = (arguments.length > 2) ?
          arguments[2] :
          (5*60000); // default ttl is 5 minutes
        var expiry = (ttl < 0) ?
          -1 : // never expires
          (new Date()).getTime()+ttl;
        //niacs.info ( "caching (expiry:"+expiry+") '"+key+"'",obj );
        cache[key] = {
          data: obj,
          expiry : expiry
        };
      },
      get : function(key) {
        var obj = cache[key];
        if ( obj == null ) {
          return arguments.length > 1 ? arguments[1] : null;
        }
        if ( obj.expiry < 0 || obj.expiry > (new Date()).getTime() ) {
          //niacs.info ( "cache entry " + key + " is valid returning." );
          return obj.data;
        }
        //niacs.info ( "cache entry " + key + " has expired." );
        // probably should slice to shrink cache array but...
        cache[key] = null;
        return arguments.length > 1 ? arguments[1] : null;
      }
    };
    return service;
})
.factory('ShowHideService',['$rootScope','$log','CacheService',function($rootScope,$log,CacheService){
  var state = [],
      accordions = {},
      firstAccordionChange = true,
      savedState;
  function changeAll(nState) {
    savedState = angular.copy(state);
    angular.forEach(state,function(item){
      item.show = nState;
    });
  }
  function getaccordionId(uniqueId){
    return niacs.endsWithId(uniqueId) ?
      uniqueId.substring(0,uniqueId.lastIndexOf('.')) : null;
  }
  var service = {
    get: function(uniqueId) {
        var cacheKey = niacs.hashCode(uniqueId),
            showHide = CacheService.get(cacheKey),
            accordionMember = arguments.length > 1 && arguments[1], accordionId;
        if(!showHide) {
          //niacs.info("caching new showHide for",$scope.uniqueId);
          showHide = {uniqueId: uniqueId, show: true, docked: false};
          CacheService.put(cacheKey,showHide,-1/*never expires*/);
        } else {
          niacs.debug("found cached showHide for '"+uniqueId+"'");
        }
        state.push(showHide);
        if(accordionMember && (accordionId=getaccordionId(uniqueId))) {
          if(!accordions[accordionId]) {
            accordions[accordionId] = {
              $order: []
            };
          }
          accordions[accordionId][uniqueId] = showHide;
          accordions[accordionId].$order.push(showHide);
        }
        return showHide;
    },
    dockedChange: function(uniqueId) {
      var panel = null,i;
      for(i = 0; i < state.length; i++) {
        if(state[i].uniqueId === uniqueId) {
          panel = state[i];
          break;
        }
      }
      if(panel) {
        var currentlyDocked = null;
        if(panel.docked) {
          currentlyDocked = panel;
          // if the change was to dock the panel then make sure
          // it's the only one that's docked.
          angular.forEach(state,function(panel) {
            panel.docked = panel.uniqueId === uniqueId;
          });
        } else {
          // if a panel was undocked then see if there is a currently docked
          // panel
          for(i = 0; i < state.length; i++) {
            if(state[i].docked) {
              currentlyDocked = state[i];
              break;
            }
          }
        }
        $rootScope.$broadcast('$dockedChange',panel,currentlyDocked);
      }
    },
    accordionChange: function(uniqueId) {
      var accordionId = getaccordionId(uniqueId),
          accordionMembers = accordionId ? accordions[accordionId] : null,
          current = accordionMembers ? accordionMembers[uniqueId] : null;
      if(current && current.show) {
        niacs.debug("accordionChange: uniqueId="+uniqueId+",accordionId="+accordionId,current/*,accordionMembers*/);
        // a member has been toggled to show, hide any other members that are currently shown
        angular.forEach(accordionMembers,function(member){
          member.show = member.uniqueId === uniqueId;
        });
        /* some day later figure this out, jQuery can be used to scroll
         * the window cleaner than angular
        if(!firstAccordionChange) {
          $timeout(function(){
            niacs.WINDOW_TOP_OFFSET = 130;
            var openTag = $("div[id='"+uniqueId.replace(/\./g,'\\.')+"']");
            $log.log('openTag',openTag);
            if(openTag && openTag.offset) {
              $log.log('attempting to scroll to ' + uniqueId);
              $('html,body').animate({scrollTop: openTag.offset().top-niacs.WINDOW_TOP_OFFSET},3000); // 'slow'
            }
          },500);
        }
        firstAccordionChange = false;
        */
      }
    },
    nextAccordion: function(uniqueId) {
      var accordionId = getaccordionId(uniqueId),
          accordionMembers = accordionId ? accordions[accordionId] : null,
          ordered = accordionMembers ? accordionMembers.$order : null,
          i;
      niacs.debug('nextAccordion',uniqueId);
      if(ordered) {
        for(i = 0; i < ordered.length; i++) {
          if(ordered[i].uniqueId === uniqueId && (i+1) < ordered.length) {
            ordered[i+1].show = true;
            return service.accordionChange(ordered[i+1].uniqueId);
          }
        }
      }
    },
    open: function(uniqueId) {
      niacs.debug('open',uniqueId);
      if(uniqueId) {
        var showHide = service.get(uniqueId);
        if(showHide) {
          showHide.show = true;
          //service.accordionChange(uniqueId);
          var lastDot = uniqueId.lastIndexOf('.'),
              pfx = lastDot ? uniqueId.substring(0,lastDot+1) : null, i;
          for(i = 0; i < state.length; i++) {
            if(state[i].uniqueId != uniqueId &&
               state[i].uniqueId.length > pfx.length && state[i].uniqueId.substring(0,pfx.length) == pfx) {
              state[i].show = false;
            }
          }
        }
      }
    },
    reset: function() {
      accordions = {};
      firstAccordionChange = true;
      state = [];
      savedState = null;
    },
    clear: function(uniqueId) {
      if(uniqueId) {
        CacheService.put(niacs.hashCode(uniqueId),null);
      }
    },
    expandAll: function() {
      $log.debug('expandAll',state);
      changeAll(true);
    },
    collapseAll: function() {
      changeAll(false);
    },
    restore: function() {
      if(state && savedState && state.length == savedState.length) {
        for(var i = 0; i < state.length; i++ ) {
          state[i].show = savedState[i].show;
        }
      }
    }
  };
  return service;
}]);
